import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@opoint/infomedia-storybook'

type Props = {
  isShown: boolean
  onHide: () => void
  onConfirm: () => void
}

const InvalidEditorSyntaxConfirmationModal = ({
  isShown,
  onHide,
  onConfirm,
}: Props) => {
  return (
    <AlertDialog
      open={isShown}
      onOpenChange={() => {
        onHide()
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            The query syntax is invalid. Are you sure you want to save it
            anyway?
          </AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button type="button" variant="outline">
              Cancel
            </Button>
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button
              onClick={() => {
                onConfirm()
              }}
              type="button"
            >
              Save
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default InvalidEditorSyntaxConfirmationModal
